<template>
  <div>
    <form ref="form" :action="company.buildCompanyRoute('meters/'+this.meter.ID)" method="post">
      <input name="_method" type="hidden" value="PATCH">
      <input type="hidden" name="_token" :value="csrf" />
      <input ref="input" type="hidden" name="confirmation_request_uuid" :value="confirmation_request_uuid" />
      <!--
      Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
      Read the documentation to get started: https://tailwindui.com/documentation
    -->
      <div v-if="permissions.isPartner()">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
              <span class="text-lg font-medium leading-6 text-gray-900">Meter Properties</span>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                This information is inherent to the meter itself -- things like radios and firmware.
              </p>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
              <div class="px-4 py-5 bg-white sm:p-6">
                <div class="grid grid-cols-6 gap-6">
                  <div class="col-span-6 sm:col-span-3">
                    <label for="device_serial_number" class="block text-sm font-medium leading-5 text-gray-700">Meter Serial Number</label>
                    <input type="text" id="device_serial_number"
                           :value="device.physical_serial"
                           disabled
                           class="bg-gray-50 mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                  </div>

                  <div class="col-span-6 sm:col-span-3">
                    <label for="device_type" class="block text-sm font-medium leading-5 text-gray-700">Device Type</label>
                    <input type="text" id="device_type"
                           :value="deviceTypeWithFirmware"
                           disabled
                           class="bg-gray-50 mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                  </div>

                  <div v-if="deviceSettingUpdateTime" class="col-span-6 sm:col-span-3">
                    <label for="last_update_time" class="block text-sm font-medium leading-5 text-gray-700">Meter Last Update</label>
                    <input type="text" id="last_update_time"
                           :value="deviceSettingUpdateTime"
                           disabled
                           class="bg-gray-50 mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                  </div>

                  <div v-for="radio in radioInfo" class="col-span-6 sm:col-span-3">
                    <label class="block text-sm font-medium leading-5 text-gray-700">Network Type</label>
                    <input type="text" :value="radio"
                           disabled
                           class="bg-gray-50 mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                  </div>
                  <div  v-if="meter.hubNovaLink != null"
                        class="col-span-6 w-full">
                    <button-blue-secondary
                                            @click="viewHubNova(false)"
                                            @click.middle="viewHubNova(true)"
                    >
                        View SoniLink Hub (Nova)
                    </button-blue-secondary>
                  </div>
                  <div  v-if="deviceProfileLink != null"
                        class="col-span-6 w-full">
                    <button-blue-secondary
                                            @click="viewDeviceProfile(false)"
                                            @click.middle="viewDeviceProfile(true)"
                    >
                        View Device/App Portal
                    </button-blue-secondary>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="permissions.isPartner()" class="hidden sm:block">
        <div class="py-5">
          <div class="border-t border-gray-200"></div>
        </div>
      </div>

      <div class="mt-10 sm:mt-0">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
              <span class="text-lg font-medium leading-6 text-gray-900">Point Info</span>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                Want a different name for your point, or maybe just a different location? You've come to the right place!
              </p>

              <!-- Room Name if it exists -->
              <div  v-if="'roomName' in meter">
                <span><b>View Room Name</b>
                <span class="rounded-full w-full my-8 px-8 py-1 text-sm font-bold bg-blue-100 text-blue-800">
                  {{ meter.roomName }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6">
                  <div class="grid grid-cols-6 gap-6">
                    <div class="col-span-6 sm:col-span-4">
                      <label for="point_name" class="block text-sm font-medium leading-5 text-gray-700">Point Name</label>
                      <input id="point_name"
                             name="name"
                             type="text"
                             v-model="meterName"
                             class="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <label for="serial_number" class="block text-sm font-medium leading-5 text-gray-700">Point Serial Number</label>
                      <input type="text" id="serial_number"
                             :value="meter.SerialNumber"
                             disabled
                             class="mt-1 bg-gray-50 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                    </div>

                    <div class="col-span-6">
                      <label for="zone" class="block text-sm font-medium leading-5 text-gray-700">Area & Zone</label>
                      <select2-group :options='areaZones'
                                     :close-on-select="true"
                                     :allow-clear="false"
                                     :multiple="false"
                                     v-model='zone'
                                     id="zone"
                                     name="zone"
                                     placeholder="Select a Zone for this point"
                                     class="p-2 m-2"
                      ></select2-group>
                    </div>

                    <div class="col-span-6 sm:col-span-3">
                      <label for="transmission_frequency" class="block text-sm font-medium leading-5 text-gray-700">Transmission Frequency</label>
                      <template v-if="canEditTransmissionFrequency">
                        <input id="transmission_frequency"
                               :value="transmissionTimeReadable"
                               class="border p-2 text-center rounded-lg w-full"
                               placeholder="HH:MM"
                               type="text"
                               @focus="openModal">
                        <input :value="transmission_frequency" name="transmission_frequency" type="hidden">
                      </template>
                      <tooltip-container v-else-if="hasPendingTransmissionFrequencyChange" :width="260" class="block w-full">
                        <input :value="transmissionTimeReadable"
                               class="bg-gray-50 border p-2 text-center rounded-lg w-full cursor-not-allowed"
                               disabled
                               type="text">
                        <template #tooltip-text>
                          A transmission frequency change is queued and waiting for the device to confirm. You can update this again once the device has applied the pending change.
                        </template>
                      </tooltip-container>
                      <tooltip-container v-else :width="260" class="block w-full">
                        <input :value="transmissionTimeReadable"
                               class="bg-gray-50 border p-2 text-center rounded-lg w-full cursor-not-allowed"
                               disabled
                               type="text">
                        <template #tooltip-text>
                          This device can't have its transmission rate updated remotely. Contact Support if you have any questions.
                        </template>
                      </tooltip-container>
                    </div>

                    <div v-if="inputNumber !== null" class="col-span-6 sm:col-span-3">
                      <label class="block text-sm font-medium leading-5 text-gray-700 mb-3">Physical Input Number</label>
                      <span :class="pillColorBasedOnInputNumber"
                            class="rounded-full w-full my-8 px-8 py-1 text-sm font-bold">Input {{ inputNumber }}</span>
                    </div>

                    <div v-if="canAssignTags" class="col-span-6 sm:col-span-3">
                      <label class="block text-sm font-medium leading-5 text-gray-700">Monitored Equipment Type</label>
                      <select2 :options="tagOptions"
                               :multiple="false"
                               name="tag_id"
                               id="tag_id"
                               v-model:value="selectedTagId"
                               placeholder="Select an equipment type (optional)"
                      ></select2>
                    </div>

                    <div v-if="permissions.can('change_meter_current_profile')" class="col-span-6 sm:col-span-3">
                      <label for="scaling_profile" class="block text-sm font-medium leading-5 text-gray-700">Scaling Profile</label>
                      <select2 :options='scalingProfiles'
                               :multiple="false"
                               name="scaling_profile"
                               id="scaling_profile"
                               v-model:value="selectedScalingProfile"
                               placeholder="Select a Scaling Profile"
                               class=""
                      ></select2>
                    </div>


                    <fieldset v-else-if="permissions.can('edit_meter') && this.scalingProfileIsTemperature && ! this.meter.is_cloudlink" class="mt-4 ml-0 pl-0 col-span-6">
                      <legend class="text-base leading-6 font-medium text-gray-900">Temperature Units</legend>
                      <div class="mt-4">
                        <div class="flex items-start">
                          <div class="flex items-center h-5">
                            <span class="relative z-0 inline-flex shadow-sm rounded-md mt-4">
                              <button
                                  type="button"
                                  @click="selectCelsius"
                                  :class="scalingProfileSelectedCelsius ? 'bg-blue-200 text-gray-800' : 'text-gray-700'"
                                  class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                Celsius
                              </button>
                              <button
                                  type="button"
                                  @click="selectFahrenheit"
                                  :class="scalingProfileSelectedFahrenheit ? 'bg-blue-200 text-gray-800' : 'text-gray-700'"
                                  class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                Fahrenheit
                              </button>
                            </span>
                          </div>
                          <div class="ml-3 text-sm leading-5">
                            <label class="font-medium text-gray-700">Want to change your temperature unit?</label>
                            <p class="text-gray-500">You are currently displaying temperature in degrees
                              <b>{{scalingProfileSelectedCelsius ? 'Celsius' : 'Fahrenheit'}}</b>.
                            </p>
                          </div>
                        </div>
                      </div>
                      <input type="hidden"
                             name="temperature_scaling_profile"
                             :value="scalingProfileSelectedCelsius ? 'c' : 'f'"
                             >
                    </fieldset>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

      <div v-if="hasDisplayAttached" class="hidden sm:block">
        <div class="py-5">
          <div class="border-t border-gray-200"></div>
        </div>
      </div>

      <div v-if="hasDisplayAttached" class="mt-10 sm:mt-0">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
              <span class="text-lg font-medium leading-6 text-gray-900">SoniShield Display</span>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                The last SoniShield Display that was connected to this meter is shown here.
              </p>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
              <div class="px-4 py-5 bg-white sm:p-6">
                <div class="grid grid-cols-6 gap-6">
                  <div class="col-span-3 sm:col-span-3">
                    <label for="display_serial" class="block text-sm font-medium leading-5 text-gray-700">Display Serial Number</label>
                    <input type="text" id="display_serial"
                           :value="device.display_serial"
                           disabled
                           class="mt-1 bg-gray-50 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                  </div>
                  <div  v-if="displayMeter !== null"
                        class="col-span-3 w-full">

                    <label for="display_serial" class="block text-sm font-medium leading-5 text-gray-700">Display Diagnostic</label>
                    <button-blue-secondary
                        @click="viewDisplay(false)"
                        @click.middle="viewDisplay(true)"
                    >
                      View Display Battery Voltage
                    </button-blue-secondary>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hidden sm:block">
        <div class="py-5">
          <div class="border-t border-gray-200"></div>
        </div>
      </div>

      <div class="mt-10 sm:mt-0">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
              <span class="text-lg font-medium leading-6 text-gray-900">Alarm Profile</span>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                You can change your alarm profile here.
              </p>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                Custom alarm profiles are modified below the big blue save button.
              </p>

                <template v-if="meterCouldCauseAlarm">
                    <div class="bg-yellow-50 border-l-2 border-yellow-400 rounded p-4 mt-2">
                        <h4 class="flex items-center text-yellow-800 font-semibold text-base m-0">
                            <span class="lnr icon-warning text-yellow-700 mr-2 !text-base !font-semibold"></span>
                            Warning
                        </h4>

                        <p class="text-sm text-yellow-800 mt-2">
                            This meter would currently trigger an alarm if it used this profile, based on the current thresholds.
                        </p>

                    </div>
                </template>

            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
              <div class="px-4 py-5 bg-white sm:p-6">
                <div class="grid grid-cols-6 gap-6">
                  <div class="col-span-6">
                    <label class="block text-sm font-medium leading-5 text-gray-700">Alarm Profile</label>
                    <select2
                        :options="alarmProfiles"
                        :multiple="false"
                        v-model:value="selectedAlarmProfile"
                        name="alarm_profile_id"
                        :close-on-select="true"
                        placeholder="Select an Alarm Profile"
                        class="w-full"
                    >
                    </select2>
                  </div>
                  <div class="col-span-6 md:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">&nbsp;</label>
                    <button @click="showModalAlarmProfile = true"
                            @click.prevent=""
                            :class="selectedAlarmProfile === 'custom' ? 'text-white bg-blue-600 hover:bg-blue-500 focus:ring-blue-200 focus:bg-blue-500 active:bg-blue-600' : 'text-blue-700 bg-white hover:bg-blue-600 hover:text-white focus:ring-blue-200 focus:border-blue-400 active:bg-blue-600'"
                            class="inline-flex w-full justify-center items-center ml-2 px-4 py-2 border-2
                               border-blue-200 text-md leading-5 font-sm
                               font-sans rounded-md focus:outline-none "
                    >
                      {{selectedAlarmProfile === 'custom' ? 'Edit' : 'View'}} Alarm Profile
                    </button>
                  </div>
                  <div class="col-span-6 md:col-span-4">
                    <label class="block text-sm font-medium leading-5 text-gray-700">&nbsp;</label>
                    <button @click="showModalUserAlarmNotificationMethods = true"
                            @click.prevent=""
                            class="inline-flex w-full justify-center items-center ml-2 px-4 py-2 border-2 border-blue-200 text-md leading-5 font-sm
                               font-sans rounded-md text-blue-700 bg-white hover:bg-blue-600 hover:text-white
                               focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-600"
                    >
                      View users that receive alarms on this point
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hidden sm:block">
        <div class="py-5">
          <div class="border-t border-gray-200"></div>
        </div>
      </div>

      <div v-if="device.probe_serial" class="mt-10 sm:mt-0">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
              <span class="text-lg font-medium leading-6 text-gray-900">Probes</span>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                Your probe and calibration info are here.
                {{device.calibration_date ? 'You can click the certificate icon to get the calibration certificate, too!' : ''}}
              </p>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="shadow overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6">
                  <div class="grid grid-cols-6 gap-6">
                    <div class="col-span-6">
                      <label for="probe_serial" class="block text-sm font-medium leading-5 text-gray-700">Probe Serial</label>
                      <input type="text" id="probe_serial"
                             :name="device.version ? '' : 'probe_serial'"
                             :value="device.probe_serial"
                             :disabled="device.version || !permissions.can('edit_probe_serial')"
                             :class="device.version || !permissions.can('edit_probe_serial') ? 'bg-gray-50' : ''"
                             class="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                    </div>

                    <div class="col-span-6 sm:col-span-2">
                      <label for="probe_calibration_date" class="block text-sm font-medium leading-5 text-gray-700">Calibration Date</label>
                      <input type="text" id="probe_calibration_date"
                             disabled
                             :value="device.calibration_date ? device.calibration_date.substring(0,10) : 'No Calibration Date Found'"
                             class="bg-gray-50 mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                    </div>

                    <div class="col-span-6 sm:col-span-2">
                      <label for="probe_calibration_expiration_date" class="block text-sm font-medium leading-5 text-gray-700">Expiration Date</label>
                      <input type="text" id="probe_calibration_expiration_date"
                             disabled
                             :value="device.calibration_expiration_date ? device.calibration_expiration_date.substring(0,10) : 'No Expiration Date Found'"
                             class="bg-gray-50 mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-200 focus:border-blue-300 sm:text-sm sm:leading-5">
                    </div>

                    <div v-if="device.calibration_date" class="col-span-6 sm:col-span-2">
                      <label for="probe_calibration_date" class="block text-sm font-medium leading-5 text-gray-700">Calibration Certificate</label>
                      <a class="plain-link" :href="calibrationLicenseLink">
                        <span class="lnr icon-license cursor-pointer" style="font-size: 2.0rem;"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

      <confirmation-modal @strict-cfr-disabled="submitEvent" @authentication-success="submitEvent">
        <template v-slot:submitAction="{ onSubmit }">
          <input v-if="canEditMeter()"
                 @click="onSubmit"
                 :disabled="!canSaveForm"
                 :value="canSaveForm ? 'Save Point' : 'Save Custom Alarm Profile (below) first'"
                 :class="canSaveForm ? 'cursor-pointer text-center bg-blue-600 hover:bg-blue-500 focus:ring-blue-200 focus:bg-blue-500 active:bg-blue-600 ' : 'cursor-not-allowed text-center bg-gray-600 hover:bg-gray-500 focus:ring-gray-200 focus:bg-gray-500 active:bg-gray-600'"
                 class="w-full mt-4 py-2 border border-transparent text-sm font-medium rounded-md text-white shadow-sm focus:outline-none"
          >
        </template>
      </confirmation-modal>

      <input v-if="customAlarmProfileId"
             type="hidden"
             name="custom_alarm_profile_id"
             :value="customAlarmProfileId"
      >

    </form>


    <hour-minute-picker
        v-model:is-open="showHourMinutePickerModal"
        :seconds="modalSeconds"
        @datePicked="listenForDatepicker"></hour-minute-picker>

    <notification-modal v-model:is-open="showScalingProfileCautionModal" :is-error-modal="true">
      <template #title-content>
        Temperature Unit Changed!
      </template>

      <p>You just changed the temperature units, so please consider also changing your alarm profile.</p>

      <p>If you had alarms set for °{{! scalingProfileSelectedCelsius ? 'Celsius' : 'Fahrenheit'}},
        they will likely cause alarms when applied to °{{scalingProfileSelectedCelsius ? 'Celsius' : 'Fahrenheit'}}.</p>
    </notification-modal>

    <notification-modal v-model:is-open="showModalNotAllowedToEdit" :is-error-modal="true">
      <template #title-content>
        Oops!
      </template>

      You can't modify this Alarm Profile from this page, because it affects multiple points.
    </notification-modal>

    <notification-modal v-model:is-open="showModalSaveSuccessful" :is-error-modal="false">
      <template #title-content>
        Congrats!
      </template>

      The alarm profile was saved successfully!
    </notification-modal>

    <slide-over-panel v-model:show="showModalUserAlarmNotificationMethods">
      <template #title>
        Users that will receive alarms
      </template>
      <template #title-content>
        See all users who are receiving alarms via<br/>
        <span class="lnr icon-smartphone-notification"></span> SMS,
        <span class="lnr icon-phone-wave"></span> Phone Call,
        <span class="lnr icon-envelope"></span> Email
        <span>
          , or <span class="lnr icon-cloud-alert"></span> SoniCloud Mobile Push Notifications.
        </span>
      </template>
      <template #content>
        <zone-users-notification-methods :zone-id="zone"></zone-users-notification-methods>
      </template>
    </slide-over-panel>

    <slide-over-panel v-model:show="showModalAlarmProfile" width="max-w-4xl">
      <template #title>
        Alarm Profile
      </template>
      <template #title-content>

      </template>
      <template #content>
        <div v-if="selectedAlarmProfile !== null && selectedAlarmProfile !== 'custom'" @click="alarmProfileEditClicked()" class="pb-10">
          <banner-error >
            <template #title>Can't Edit Alarm Profile</template>
            <template #content-mobile>You can't edit this alarm profile from here</template>
            <template #content>
              You can't edit this alarm profile from this page;
              info below is presented to help you understand the behavior of the selected alarm profile.
            </template>
          </banner-error>
          <alarm-profiles-edit :id="parseInt(selectedAlarmProfile)"
                               :disable-submit="true"
                               :timezone-abbreviated='timezoneAbbreviated'
          ></alarm-profiles-edit>
        </div>
        <div v-else class="mt-10">
          <alarm-profiles-edit :id="isCustomProfileThatAlreadyExists ? parseInt(customAlarmProfileId) : null"
                               :disable-submit="false"
                               :is-ajax="true"
                               v-on:profileSaved="alarmProfileCreated"
                               :private-mode="true"
                               :default-name="customProfileDefaultName"
                               :timezone-abbreviated='timezoneAbbreviated'
          ></alarm-profiles-edit>
        </div>
      </template>
    </slide-over-panel>

  </div>
</template>

<script>
import Select2 from "@/components/elements/select2";
import Toggle from "@/components/elements/toggle";
import Select2Group from "@/components/elements/select2-group";
import {capitalize, isNil} from 'lodash';
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import NotificationModal from "@/components/elements/NotificationModal";
import HourMinutePicker from "@/components/elements/hourMinutePicker";
import BannerError from "@/components/Banners/BannerError";
import SonicuHeader from "@/components/elements/SonicuHeader";
import alarmProfilesEdit from "@/components/alarmProfiles/alarmProfilesEdit";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import ZoneUsersNotificationMethods from "@/components/zoneUsersNotificationMethods";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import ConfirmationModal  from "@/components/elements/ConfirmationModal";
import TooltipContainer from "@/components/elements/TooltipContainer";
import axios from "axios";

export default {
  name: "meterEdit",
  components: {
      ButtonBlueSecondary,
    ZoneUsersNotificationMethods,
    SlideOverPanel,
    NotificationModal, Select2Group, Select2, Toggle, HourMinutePicker, BannerError, SonicuHeader, alarmProfilesEdit, ConfirmationModal, TooltipContainer},
  mixins: [SonicuCoreMixin],
  props: {
    areaZones: Object,
    meter: Object,
    device: Object,
    scalingProfiles: Object,
    inputNumber: {
      type: Number,
      default: null,
    },
    alarmProfiles: Object,
    displayMeter: Object,
    canAssignTags: {
      type: Boolean,
      default: false,
    },
    sonicuAiTags: {
      type: Array,
      default: () => [],
    },
    currentTagId: {
      type: Number,
      default: null,
    },
    timezoneAbbreviated: String,
    couldAlarm: Array,
  },
  data(){
    return {
      zone: this.meter.ZoneID,
      showHourMinutePickerModal: false,
      showHourMinutePickerModalEvent: null,
      modalSeconds: null,
      transmission_frequency: this.meter.transmission_frequency,
      selectedScalingProfile: this.meter.current_profile.ProfileID,
      selectedAlarmProfile: this.meter.alarm_profile_id,
      scalingProfileSelectedCelsius: false,
      scalingProfileSelectedFahrenheit: false,
      scalingProfileIsTemperature: false,
      showScalingProfileCautionModal: false,
      showModalNotAllowedToEdit: false,
      showModalSaveSuccessful: false,
      showModalUserAlarmNotificationMethods: false,
      showModalAlarmProfile: false,
      isCustomProfileThatAlreadyExists: false,
      customAlarmProfileId: null,
      meterName: this.meter.Name,
      deviceProfileLink: null,
      confirmation_request_uuid: null,
      selectedTagId: this.currentTagId ? this.currentTagId.toString() : null,
    }
  },
  created() {
    this.prepareTemperatureProfileButtons();
    if(! (this.selectedAlarmProfile in this.alarmProfiles)){
      this.isCustomProfileThatAlreadyExists = true;
      this.customAlarmProfileId = this.selectedAlarmProfile;
      this.selectedAlarmProfile = 'custom';
    }

    this.deviceProfileLink = this.meter.deviceProfile;
  },
  computed: {
    radioInfo() {
      let results = [];
      Object.keys(this.meter.network_devices).forEach(key => {
        results.push(this.meter.network_devices[key] + " (" + capitalize(key) + ")");
      });
      return results;
    },
    deviceTypeWithFirmware(){
      return this.device.product_name + " (" + this.device.version + ")";
    },
    canEditTransmissionFrequency(){
      const supported = Boolean(this.meter.is_sonishield) || Boolean(this.meter.is_s_series);
      return supported && ! this.hasPendingTransmissionFrequencyChange;
    },
    hasPendingTransmissionFrequencyChange(){
      return Boolean(this.meter.transmission_frequency_change_pending);
    },
    transmissionTimeReadable(){
      if(isNil(this.transmission_frequency)){
        return '';
      }
      let minutes = this.transmission_frequency / 60;
      let hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return hours.toString().padStart(2,"0") + ":" + minutes.toString().padStart(2,"0");
    },
    pillColorBasedOnInputNumber() {
      if (this.inputNumber === 1) {
        return 'bg-blue-100 text-blue-800';
      }
      if (this.inputNumber === 2) {
        return 'bg-green-100 text-green-800';
      }
      if (this.inputNumber === 3) {
        return 'bg-yellow-100 text-yellow-800';
      }
      if (this.inputNumber === 4) {
        return 'bg-red-100 text-red-800';
      }
    },
    calibrationLicenseLink() {
      return this.company.buildCompanyRoute('files/calibration-certificate?serial=' + this.meter.SerialNumber)
    },
    canSaveForm(){
      if(this.isCustomProfileThatAlreadyExists){
        return true;
      }
      if(this.selectedAlarmProfile === 'custom' && this.customAlarmProfileId === null){
        return false;
      }
      return true;
    },
    deviceSettingUpdateTime(){
      let lastUpdateTime = null;
      if(this.device.settings){
        this.device.settings.forEach( setting => {
          if(setting.SettingName === 'device_type'){
            lastUpdateTime = setting.Updated;
          }
        })
      }
      if(lastUpdateTime === null){
        return null;
      }

      let deltaSeconds = Math.floor((Date.now() / 1000) - lastUpdateTime);
      if( deltaSeconds < 60){
        return deltaSeconds.toString() + " seconds ago";
      }
      if( deltaSeconds < 3600){
        return Math.floor((deltaSeconds / 60)).toString() + " minutes ago";
      }
      if( deltaSeconds < 86400){
        return Math.floor((deltaSeconds / 3600)).toString() + " hours ago";
      }
      return Math.floor((deltaSeconds / 86400)).toString() + " days ago";
    },
    customProfileDefaultName(){
      return this.meterName + ' Custom Alarm Profile';
    },
    hasDisplayAttached(){
      return this.device.display_serial != null;
    },
    tagOptions() {
      let options = {}
      this.sonicuAiTags.forEach(tag => {
        options[tag.id.toString()] = tag.name
      })
      return options
    },
    displayLink(){
      if(_.isNil(this.displayMeter)){
        return null;
      }
      return this.company.buildCompanyRoute("meters/" + this.displayMeter.ID);
    },
    meterCouldCauseAlarm() {
        return this.couldAlarm[this.selectedAlarmProfile] &&
            Number(this.meter.alarm_profile_id) !== Number(this.selectedAlarmProfile);
    }
  },
  methods: {
    prepareTemperatureProfileButtons(){
      if(this.meter.current_profile){
        if(this.meter.current_profile.is_temperature_profile){
          if(this.meter.current_profile.is_celsius_profile){
            this.scalingProfileIsTemperature = true;
            this.scalingProfileSelectedCelsius = true;
          }
          if(this.meter.current_profile.is_fahrenheit_profile){
            this.scalingProfileIsTemperature = true;
            this.scalingProfileSelectedFahrenheit = true;
          }
        }
      }
    },
    openModal(e){
      this.showHourMinutePickerModalEvent = e;
      this.modalSeconds = parseInt(this[e.srcElement.id]);
      this.showHourMinutePickerModal = true;
    },
    listenForDatepicker(val){
      const seconds = val === null ? null : val.seconds;
      this[this.showHourMinutePickerModalEvent.srcElement.id] = seconds;
      this.showHourMinutePickerModalEvent = null;
    },
    selectCelsius(){
      if(! this.scalingProfileSelectedCelsius){
        // We only want to show the modal IFF they are changing their selection.
        this.showScalingProfileCautionModal = true;
      }
      this.scalingProfileSelectedCelsius = true;
      this.scalingProfileSelectedFahrenheit = false;
    },
    selectFahrenheit(){
      if(! this.scalingProfileSelectedFahrenheit){
        // We only want to show the modal IFF they are changing their selection.
        this.showScalingProfileCautionModal = true;
      }
      this.scalingProfileSelectedCelsius = false;
      this.scalingProfileSelectedFahrenheit = true;
    },
    alarmProfileEditClicked(){
      let el = document.querySelector( ':focus' );
      if( el ) el.blur();
      this.showModalNotAllowedToEdit = true;
    },
    alarmProfileCreated(e){
      if(this.isCustomProfileThatAlreadyExists){
        // Nothing, we'll just pass on this.
      } else {  // Didn't exist, so persist the extra info so we can use a hidden input
        this.customAlarmProfileId = e.data.id;
      }
      this.showModalSaveSuccessful = true;
    },
    viewDeviceProfile(isMiddle) {
      if (isMiddle) {
        window.open(this.deviceProfileLink, '_blank')
      }
      else {
        window.location.href = this.deviceProfileLink
      }
    },
    viewHubNova(isMiddle) {
      if (isMiddle) {
        window.open(this.meter.hubNovaLink, '_blank')
      }
      else {
        window.location.href = this.meter.hubNovaLink
      }
    },
    viewDisplay(isMiddle) {
      if (isMiddle) {
        window.open(this.displayLink, '_blank')
      }
      else {
        window.location.href = this.displayLink
      }
    },
    canEditMeter() {
        return this.permissions.can('update_meter')
    },
    submitEvent(confirmationRequestUuid = null) {

      this.confirmation_request_uuid = confirmationRequestUuid;

      // I have no idea why the V-Bind does not work on the hidden input, this forces the value to update.
      this.$refs.input.value = this.confirmation_request_uuid;
      this.$refs.form.submit();
    },
  },
}
</script>

<style scoped>

</style>